import { render, staticRenderFns } from "./SyncChanges.vue?vue&type=template&id=ea52af4c&scoped=true&"
import script from "./SyncChanges.vue?vue&type=script&lang=js&"
export * from "./SyncChanges.vue?vue&type=script&lang=js&"
import style0 from "./SyncChanges.vue?vue&type=style&index=0&id=ea52af4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea52af4c",
  null
  
)

export default component.exports